__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@frontend20/automations";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@moosend/mooskin", "1.1.4", () => (Promise.all([__webpack_require__.e("vendors-node_modules_moosend_mooskin_lib_index_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__(/*! ../../node_modules/@moosend/mooskin/lib/index/index.js */ "../../node_modules/@moosend/mooskin/lib/index/index.js"))))));
			register("history", "4.10.1", () => (__webpack_require__.e("vendors-node_modules_history_esm_history_js").then(() => (() => (__webpack_require__(/*! ../../node_modules/history/esm/history.js */ "../../node_modules/history/esm/history.js"))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("node_modules_object-assign_index_js")]).then(() => (() => (__webpack_require__(/*! ../../node_modules/react-dom/index.js */ "../../node_modules/react-dom/index.js"))))));
			register("react-router-dom", "4.3.1", () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-router-dom_es_index_js"), __webpack_require__.e("webpack_sharing_consume_default_history_history-webpack_sharing_consume_default_react_react"), __webpack_require__.e("node_modules_invariant_browser_js-node_modules_prop-types_index_js-node_modules_warning_warni-6759ca")]).then(() => (() => (__webpack_require__(/*! ./node_modules/react-router-dom/es/index.js */ "./node_modules/react-router-dom/es/index.js"))))));
			register("react", "16.14.0", () => (__webpack_require__.e("node_modules_react_index_js-_11190").then(() => (() => (__webpack_require__(/*! ../../node_modules/react/index.js */ "../../node_modules/react/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};